import React, { useEffect, useRef } from 'react';
import './IntroText.scss';
import Letterize from 'letterizejs';
import gsap from 'gsap';
import Typewriter from 'typewriter-effect';

const IntroText = props => {
  const nameTextRef = useRef(null);

  useEffect(() => {
    const introChars = new Letterize({ targets: '.name-text', wrapper: 'div' });

    const chars = introChars.listAll;

    const tl = gsap.timeline({
      onComplete: () => {
        nameTextRef.current?.classList.add('hover-letters');
      },
      onStart: () => {
        nameTextRef.current?.classList.remove('hover-letters');
      },
    });

    tl.from(chars, {
      duration: 1,
      delay: 1,
      opacity: 0,
      scale: 0,
      y: 80,
      rotationX: 180,
      transformOrigin: '0% 50% -50',
      ease: 'back',
      stagger: 0.01,
    });
  }, []);

  return (
    <div className="intro-text-container">
      <div ref={nameTextRef} className="name-text">
        <p className="my-flex">Hi! I'm</p>
        <p className="name my-flex">Moid</p>
      </div>
      <Typewriter
        options={{
          strings: ['A Full Stack Dev', 'A Frontend Dev', 'A UI Developer'],
          autoStart: true,
          loop: true,
        }}
      />
    </div>
  );
};

export default IntroText;
